window.addEventListener('DOMContentLoaded', () => {
	init();
});

function init() {
	const currentLang = document.documentElement.lang;

	addApp(currentLang);
	addScript();
}

function addApp(currentLang: string) {
	const orgID = 'mBuCjbO9pLLl6bWjOqmA'; // ID OF ORG

	const attach = 'body'; // ELEMENT TO ATTACH TO
	const auto = 'false'; // AUTOMATICALLY OPEN POPUP (NO BUTTON PRESS)
	const limit = '0'; // SET LIMIT ON AUTOMATICALLY OPENING POPUP (0 UNLIMITED, NOT TAKEN INTO ACCOUNT IF AUTO IS FALSE)
	const disableDismiss = 'true'; // DISABLE DISMISS ON CLICK OUTSIDE (FOR POPUPS)
	const disableNoscroll = 'true'; // DISABLE THE NOSCROLL THAT GETS APPLIED ONTO THE BODY BY DEFAULT

	let text = 'Puhdasta vettä mökille – aloita tästä!'; // label of popup opener
	let questID = 'bzzHhScdyOdKUGLZ39h4'; // Quest ID

	// Resulting template
	const appHTML = `
<div
    class="jquest-app"
    data-new-styles="true"
    data-locale="${currentLang}"
    data-org-id="${orgID}"
    data-game-id="${questID}"
    data-popup="true"
    data-popup-auto="${auto}"
    data-popup-limit=${limit}
    data-popup-attach="${attach}"
    data-popup-disable-dismiss="${disableDismiss}"
    data-popup-disable-noscroll="${disableNoscroll}"
></div>
`;

	const appExists = document.querySelector(`.jquest-app[data-game-id='${questID}']`);

	if (appExists) {
		return;
	}

	// Append to body
	document.body.insertAdjacentHTML('beforeend', appHTML);

	// If not automatic, should add toggler
	// REMOVE THIS IF ADDING SEPARATE TOGGLER
	if (auto === 'false') {
		addToggler(questID, text);
	}
}

function addToggler(questID: string, text: string) {
	const toggleStyle = `
		<style>
		.jquest-app[data-game-id='${questID}'][data-popup='true'] {
			display: none;
		}
		.jquest-popup-toggle {
			position: fixed;
			bottom: 1rem;
			right: 1rem;
			z-index: 99;
			height: 42px;
			max-width: 100%;

			a {
				position: relative;
				background-color: var(--wp--preset--color--brand);
				cursor: pointer;
				border-radius: 25px;
				text-decoration: none;
				color: white;
				padding: 11px 53px 11px 23px;
    			font-weight: 400;

				.icon-container {
					position: absolute;
					border-radius: 50%;
					background-color: white;
					right: 8px;
					top: 50%;
					transform: translateY(-50%);
					height: 29px;
					width: 29px;
					display: flex;
					justify-content: center;
					align-items: center;
				}

				.jquest-app {
					display: none;
				}
			}

			a:hover {
				background-color: var(--wp--preset--color--darkerblue);
			}
}
		</style>
		`;

	const toggleHTML = `
		<div class="jquest-popup-toggle">
			<a href="#jquest-popup-${questID}">${text}
				<div class="icon-container">
					<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			        	<path d="M5.6 15.675L9.1 13.05C9.14375 13.0187 9.19687 13 9.25 13H13C14.6562 13 16 11.6562 16 10V3C16 1.34375 14.6562 0 13 0H3C1.34375 0 0 1.34375 0 3V10C0 11.6562 1.34375 13 3 13H4V15.125C4 15.6094 4.39062 16 4.875 16C5.06563 16 5.25 15.9375 5.4 15.825L5.6 15.675ZM5 13V12.75C5 12.3344 4.66563 12 4.25 12H3C1.89688 12 1 11.1031 1 10V3C1 1.89688 1.89688 1 3 1H13C14.1031 1 15 1.89688 15 3V10C15 11.1031 14.1031 12 13 12H9.25C8.97812 12 8.71562 12.0875 8.5 12.25L5 14.875V13ZM4.5 5C4.225 5 4 5.225 4 5.5C4 5.775 4.225 6 4.5 6H11.5C11.775 6 12 5.775 12 5.5C12 5.225 11.775 5 11.5 5H4.5ZM4.5 8C4.225 8 4 8.225 4 8.5C4 8.775 4.225 9 4.5 9H8.5C8.775 9 9 8.775 9 8.5C9 8.225 8.775 8 8.5 8H4.5Z" fill="#1A2E40"></path>
			        </svg>
		        </div>
        	</a>
		</div>
		`;

	// Append to body
	document.body.insertAdjacentHTML('beforeend', toggleStyle);
	document.body.insertAdjacentHTML('beforeend', toggleHTML);
}

function addScript() {
	// Change between latest or stable depending on use case
	const scriptURL = 'https://files.jquest.fi/jquest/latest/jquest-latest.js';
	//const scriptURL = 'https://files.jquest.fi/jquest/stable/jquest-stable.js';

	// Check if already loading jquest script
	const exists = Array.from(document.scripts).some((script) =>
		script.src.startsWith('https://files.jquest.fi/jquest/')
	);

	if (exists) {
		return;
	}

	const script = document.createElement('script');
	script.src = scriptURL;
	script.type = 'module';
	script.setAttribute('data-cookieconsent', 'ignore');

	document.head.appendChild(script);
}
